import { useRef, type KeyboardEvent } from 'react';

export type TabItem<T extends string> = { value: T; label: string };

export type TabsProps<T extends string> = {
  label: string;
  items: TabItem<T>[];
  value: T;
  onChange: (value: T) => void;
};

/**
 * Abas do pacote (`.card.tabs`). Nas integrações elas levam até a seção da página,
 * por isso são navegação (`nav` + `aria-current`), não um tablist com painéis.
 */
export function Tabs<T extends string>({ label, items, value, onChange }: TabsProps<T>) {
  const ref = useRef<HTMLElement>(null);
  const onKey = (e: KeyboardEvent) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    const buttons = Array.from(ref.current?.querySelectorAll('button') ?? []);
    const i = buttons.indexOf(document.activeElement as HTMLButtonElement);
    if (i < 0) return;
    e.preventDefault();
    buttons[(i + (e.key === 'ArrowLeft' ? -1 : 1) + buttons.length) % buttons.length].focus();
  };
  return (
    <nav className="card tabs" aria-label={label} ref={ref} onKeyDown={onKey}>
      {items.map((it) => (
        <button key={it.value} type="button" className={value === it.value ? 'on' : ''} aria-current={value === it.value ? 'true' : undefined} data-go={it.value} onClick={() => onChange(it.value)}>
          {it.label}
        </button>
      ))}
    </nav>
  );
}
